import React from "react";
interface Props {
  children?: React.ReactNode;
}
const LoginLayout = ({ children }: Props) => {
  return <>{children}</>;
};

export default LoginLayout;
